import { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography
} from "@mui/material";
import API from "../services/api";

export default function MyAccount() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          setLoading(false);
          return;
        }

        const res = await API.get("/auth/me", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setUser(res.data);

      } catch (err) {
        console.log("ERROR /me:", err?.response?.data || err.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // =========================
  // LOADING STATE
  // =========================
  if (loading) {
    return (
      <div style={{ color: "#fff", textAlign: "center", marginTop: "100px" }}>
        Cargando perfil...
      </div>
    );
  }

  // =========================
  // NO USER STATE
  // =========================
  if (!user) {
    return (
      <div style={{ color: "#fff", textAlign: "center", marginTop: "100px" }}>
        No hay sesión activa
      </div>
    );
  }

  // =========================
  // UI
  // =========================
  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "linear-gradient(180deg, #141414, #2a1208)"
    }}>
      <Paper sx={{
        p: 4,
        width: 400,
        background: "rgba(20,20,20,0.9)",
        border: "1px solid rgba(255,110,0,0.3)"
      }}>

        <Typography variant="h5" sx={{ color: "#fff", mb: 2 }}>
          Mi Perfil
        </Typography>

        <Typography sx={{ color: "#fff" }}>
          Usuario: {user.username}
        </Typography>

        <Typography sx={{ color: "#fff" }}>
          Email: {user.email || "No cargado"}
        </Typography>

        <Typography sx={{ color: "#fff" }}>
          Discord: {user.discordId || "No cargado"}
        </Typography>

        <Typography sx={{ color: "#fff" }}>
          Riot: {user.riotId || "No cargado"}
        </Typography>

        <Typography sx={{ color: "#fff" }}>
          Teléfono: {user.phone || "No cargado"}
        </Typography>

        <Typography sx={{
          color: user.isVerified ? "lightgreen" : "orange",
          mt: 2
        }}>
          {user.isVerified ? "Cuenta verificada" : "Cuenta sin verificar"}
        </Typography>

      </Paper>
    </Box>
  );
}